<template>
  <v-layout
    v-if="isLoading"
    :style="`height: ${height}px;`"
    align-center
    justify-center
    fill-height
  >
    <v-progress-circular color="primary" indeterminate />
  </v-layout>
</template>

<script>
import { STATUS_IS_LOADING } from 'utils/constants'

export default {
  name: 'Loading',
  props: {
    status: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    }
  }
}
</script>
